import { render } from "./unsubscribeconfirmdialog.vue?vue&type=template&id=32bbbda9"
import script from "./unsubscribeconfirmdialog.vue?vue&type=script&lang=js"
export * from "./unsubscribeconfirmdialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../Users/martijn/Documents/GitHub/dfm/DFM-user-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__